// extracted by mini-css-extract-plugin
export var bubble = "_3o-0";
export var container = "_3o-f";
export var contrastBorder = "_3o-g";
export var greyOut = "_3o-2";
export var initialsColor0 = "_3o-3";
export var initialsColor1 = "_3o-4";
export var initialsColor10 = "_3o-d";
export var initialsColor11 = "_3o-e";
export var initialsColor2 = "_3o-5";
export var initialsColor3 = "_3o-6";
export var initialsColor4 = "_3o-7";
export var initialsColor5 = "_3o-8";
export var initialsColor6 = "_3o-9";
export var initialsColor7 = "_3o-a";
export var initialsColor8 = "_3o-b";
export var initialsColor9 = "_3o-c";
export var initialsWrapper = "_3o-1";
export var large = "_3o-l";
export var medium = "_3o-k";
export var mediumSmall = "_3o-j";
export var mediumSmallMedium = "_3o-o";
export var micro = "_3o-h";
export var small = "_3o-i";
export var tiny = "_3o-n";
export var xTiny = "_3o-m";